import { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { NA_VALUE } from 'commons-ui';

const useView = () => {
	const [showLoader, setShowLoader] = useState(false);
	const history = useHistory();
	const location = useLocation();

	const handleFormSubmit = () => {};
	const handleFormCancel = () => {
		history.goBack();
	};
	let data = _get(location, ['state', 'rowData']);
	if (data && typeof data === 'object') {
		data = {
			...data,
			scheduledAtTimestamp: !data.scheduledAtTimestamp ? NA_VALUE : data.scheduledAtTimestamp
		};
	}
	return { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};
export default useView;
